var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVector98X2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.814,21.15C31.814,20.792 31.682,20.449 31.446,20.195C31.211,19.942 30.891,19.8 30.558,19.8L25.535,19.8C25.202,19.8 24.882,19.942 24.647,20.195C24.411,20.449 24.279,20.792 24.279,21.15L24.279,33.3L21.767,33.3L21.767,4.05C21.767,2.74 21.764,1.89 21.687,1.267C21.613,0.682 21.495,0.499 21.399,0.396C21.304,0.293 21.133,0.166 20.589,0.086C20.008,0.004 19.219,0 18,0C16.781,0 15.991,0.004 15.411,0.086C14.867,0.166 14.696,0.293 14.601,0.396C14.505,0.499 14.387,0.682 14.313,1.267C14.236,1.892 14.233,2.74 14.233,4.05L14.233,33.3L11.721,33.3L11.721,12.15C11.721,11.792 11.589,11.449 11.353,11.195C11.118,10.942 10.798,10.8 10.465,10.8L5.442,10.8C5.109,10.8 4.789,10.942 4.554,11.195C4.318,11.449 4.186,11.792 4.186,12.15L4.186,33.3L1.256,33.3C0.923,33.3 0.603,33.442 0.368,33.695C0.132,33.949 0,34.292 0,34.65C0,35.008 0.132,35.351 0.368,35.605C0.603,35.858 0.923,36 1.256,36L34.744,36C35.077,36 35.397,35.858 35.632,35.605C35.868,35.351 36,35.008 36,34.65C36,34.292 35.868,33.949 35.632,33.695C35.397,33.442 35.077,33.3 34.744,33.3L31.814,33.3L31.814,21.15Z",
    fill: "#2D2626"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVector98X2);
export default __webpack_public_path__ + "static/media/vector_98_x2.0fee37f93aaedcc60cdbea6a741bde7b.svg";
export { ForwardRef as ReactComponent };